import React, {useMemo} from 'react';
import {useProjectFormMailReportsByCapitalFundRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();
  const {data: {projectFormMailReportsByCapitalFundRange = []} = {}} =
    useProjectFormMailReportsByCapitalFundRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectFormMailReportsByCapitalFundRange.map((report) => {
        return {
          name: report.capitalFundRange,
          mailCount: report.mailCount,
          clickCount: report.clickCount,
          clickRate: report.clickRate,
          replyCount: report.replyCount,
          replyRate: report.replyRate,
          appointCount: report.appointCount,
          appointRate: report.appointRate,
        };
      }),
    [projectFormMailReportsByCapitalFundRange],
  );

  return <Table data={data} />;
};
